import { useEffect, useState } from "react";
import { Scissors } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel, Spinner } from "@/components/common";

const FIELDS = [["min_clicks", "Min clicks with 0 leads", 1], ["spend_multiple", "Spend ≥ × clinic cost per lead (0 leads)", 0.1], ["min_spend", "…and at least S$", 10], ["cpl_multiple", "Cost per lead ≥ × clinic cost per lead", 0.1]];

export default function TrimHoursSettings() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/trim-hours").then((r) => setS(r.data)); }, []);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/settings/trim-hours", Object.fromEntries(FIELDS.map(([k]) => [k, Number(s[k])]))); setS(data); toast.success("Trim weak hours thresholds saved"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!s) return <Spinner />;
  return (
    <Panel title="Trim weak hours" icon={Scissors} testid="trim-settings-panel">
      <p className="mb-4 text-sm text-slate-400">Checked in the daily sync once the 7am–11pm schedule has been live {s.wait_days}+ days. Weak extra-hours blocks become one high-risk proposal you approve. Never auto-executed; clinic hours, budgets and bids are never touched. A rejected block isn't suggested again for {s.cooldown_days} days.</p>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {FIELDS.map(([k, label, step]) => (
          <label key={k} className="text-xs text-slate-400">{label}
            <input data-testid={`trim-${k}`} type="number" step={step} className="cc-input mt-1 w-full" value={s[k]} onChange={(e) => setS({ ...s, [k]: e.target.value })} />
          </label>
        ))}
      </div>
      <button data-testid="trim-settings-save" onClick={save} disabled={busy} className="cc-btn cc-btn-primary mt-4 px-3 py-1.5 text-xs">{busy ? <Spinner className="h-3.5 w-3.5" /> : null} Save thresholds</button>
    </Panel>
  );
}
